import {injectGlobal} from "styled-components"
import * as vars from "../style/vars"
import {above, below, clearFix} from "../style/functions"

injectGlobal `
.cf{
	${clearFix()}

}
	.grid{
		width: 100%;
		margin: auto;
		max-width: calc(160rem + ${ (vars.padding.inner * 2)}rem);
		padding-left: ${vars.padding.inner}rem;
		padding-right: ${vars.padding.inner}rem;
		position: relative;
		${clearFix()}
		.inner{
			padding-left: 13.25rem;
			${clearFix()}
			${below.giant `
				padding-left: 0;
			`}
		}
		${below.tablet`
			padding-left: ${vars.padding.tabInner}rem;
			padding-right: ${vars.padding.tabInner}rem;
		`}
		${below.mobile`
			padding-left: ${vars.padding.mobInner}rem;
			padding-right: ${vars.padding.mobInner}rem;
		`}
		.pull-left{
			float: left;
		}
		.pull-right{
			float:right;
		}
		.col{
			float: left;
			display:block;
			${above.tablet`
			&.padd{
				padding-left: ${(vars.padding.inner / 2)}rem;
				padding-right: ${(vars.padding.inner / 2)}rem;
			}
			&.padd-l{
				padding-left: ${(vars.padding.inner / 2)}rem;
			}
			&.padd-r{
				padding-right: ${(vars.padding.inner / 2)}rem;
			}
			&.col-12 {
				width: 100%;
			}
			&.col-11 {
					width: 91.66%;
			}
			&.col-10 {
					width: 83.33%;
			}
			&.col-09 {
					width: 75%;
			}
			&.col-08 {
					width: 66.66%;
			}
			&.col-07 {
					width: 58.33%;
			}
			&.col-06 {
					width: 50%;
			}
			&.col-05 {
					width: 41.66%;
			}
			&.col-04 {
					width: 33.33%;
			}
			&.col-03 {
					width: 25%;
			}
			&.col-02 {
					width: 16.66%;
			}
			&.col-01 {
					width: 8.333%;
			}
			`}
			${below.desktop`
			&.col-xs-12 {
				width: 100%;
				float:none;
			}
			&.col-xs-11 {
					width: 91.66%;
		}
			&.col-xs-10 {
					width: 83.33%;
	}
			&.col-xs-09 {
					width: 75%;
	}
			&.col-xs-08 {
					width: 66.66%;
		}
			&.col-xs-07 {
					width: 58.33%;
	}
			&.col-xs-06 {
					width: 50%;
	}
			&.col-xs-05 {
					width: 41.66%;
			}
			&.col-xs-04 {
					width: 33.33%;
			}
			&.col-xs-03 {
					width: 25%;
			}
			&.col-xs-02 {
					width: 16.66%;
			}
			&.col-xs-01 {
					width: 8.333%;
			}
			`}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/style/col.js